/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import SubscribeConfirmation from "./SubscribeConfirmation";

export default SubscribeConfirmation;
